import axios from "axios";
import { getEnvs } from "./utils";
// import Cookies from "js-cookie";
import { customStorage } from "@/hooks/CustomLocalStorage";

const { PDMG_API_URL } = getEnvs();

axios.defaults.baseURL = PDMG_API_URL + "/";
// axios.defaults.withCredentials = true;
axios.defaults.headers.common["Content-Type"] = "multipart/form-data";
axios.interceptors.request.use(function (config) {
	// sessionStorage
	const accessToken = customStorage.getItem("access_token");
	if (accessToken) {
		config.headers["Authorization"] = `Bearer ${accessToken}`;
	}

	const apiRefreshToken = customStorage.getItem("api_refresh_token");
	if (apiRefreshToken) {
		config.headers["X-Api-Refresh-Token"] = apiRefreshToken;
	}

	const agentId = customStorage.getItem<string>("agent_id");
	if (agentId) {
		config.headers["X-Api-Agent-Id"] = agentId;
	}

	return config;
});

export { axios as fetchApi };
